import script from "./AppearanceToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./AppearanceToggle.vue?vue&type=script&setup=true&lang=js"

import "./AppearanceToggle.vue?vue&type=style&index=0&id=44af4414&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44af4414"]])

export default __exports__